import Swal from "sweetalert2";

const dimentionsValidations = e => {
  if (!e.target.value) return;
  if (typeof parseFloat(e.target.value) !== "number") return;

  const value = parseFloat(e.target.value);

  if (value > 100) {
    Swal.fire({
      icon: "error",
      title: "اخطار",
      html: "<p style='font-size: 20px'>مرسوله با طول یا عرض یا ارتفاع بیشتر از 100 سانتی متر در یک بسته توسط اداره پست حمل نمیشود<br>مرسولات با طول یا عرض یا ارتفاع بیشتر از 100 سانتی متر تا 250 سانتی متر توسط سرویس های ماهکس و چاپار و ... حمل میگردد </p>",
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> فهمیدم',
      confirmButtonColor: "red",
      iconColor: "red",
    });
  }
};

export default dimentionsValidations;
